//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchGeometryBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
let d=[[[1,"Height",0,"Expression",0],[0,"LockHeight",1,0],[0,"LockWidth",1,0],[1,"Width",0,"Expression",0]],[[["basePoint"],"SetBasePoint",{},1,0],[["basePoint"],"SnapBasePoint",{},1,0],[["diagonalPoint"],"SetDiagonalPoint",{},1,0],[["diagonalPoint"],"SnapDiagonalPoint",{},1,0]],[]];
SPLM.SketchRectangleBuilder = class extends SPLM.SketchGeometryBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchRectangleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;